export default __webpack_public_path__ + "static/media/github2.4ec58677.svg";